module.exports = __webpack_public_path__ + "static/media/note-email-green.42af2561.svg";